import React from "react"
import { Link, Image } from "@chakra-ui/react"
import { getAppleWalletPassUrl } from "utilities/walletPass"

type Props = {
  guestExternalId: string
  language: string
}

const AddToWallet = ({ guestExternalId, language }: Props) => (
  <Link isExternal href={getAppleWalletPassUrl(guestExternalId)}>
    <Image
      src={`/add-to-wallet/${language}.svg`}
      alt="Add to Apple Wallet"
      height={41}
    />
  </Link>
)

export default AddToWallet
